import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { WebpartContainer } from '../containers'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import * as typesWebpart from '@webparts/store/types'
import * as typesAccount from '@account/store/types'
import { FullMasterTemplate } from '@/modules/@appbase/templates'

import PopupNotioce from '@home/components/PopupNotice/PopupNotice.vue'
import AttendanceSideBar from '@home/components/Attendance/AttendanceSideBar.vue'
import FixedWebpartContainer from '@home/containers/FixedWebpartContainer/FixedWebpartContainer.vue'
import WebpartPage from '@webparts/components/webpart-page/WebpartPage.vue'
import webpartApi from '@webparts/api'
import SystemQuickMenu from '@home/containers/FixedWebpartContainer/SystemQuickMenu.vue'

import TotalSystemModal from '@home/views/HK_TotalSystem/TotalSystemModal.vue'
import * as appbaseTypes from '@appbase/store/types'
import { WebpartDataType } from '@webparts/types/enums'

@Component({
    components: { WebpartContainer, FullMasterTemplate, AttendanceSideBar, FixedWebpartContainer, WebpartPage, SystemQuickMenu, PopupNotioce },
    computed: {
        ...mapGetters({
            user: typesAccount.USER,
            current: typesAccount.CURRENT,
        }),
    },
    methods: {
        ...mapActions({
            loadCommonInfo: typesWebpart.WEBPART_COMMONDATA
        }), 

        ...mapMutations({
            setTeams: appbaseTypes.TEAMS,
        })
    }
})
export default class HomeView extends Vue {
    setTeams!: (value: boolean) => void
    loadCommonInfo!: (types: WebpartDataType[]) => Promise<any>;
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    user!: account.User;
    current!: account.TCurrent

    isEnablePopupNotice: boolean = false

    useAttendance: boolean = false
    pageId: number = 1
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    openPop(flag:string) {
        let host = window.location.origin
        let param = ''
        let target = ''
        let title = ''
        const licence = (this.user as any).m365License;
        if (process.env.NODE_ENV === 'production'){
            if (licence == 1) {
                host += '/po2'
            } else {
                host += '/po'
            }
        }
        if(flag.toLowerCase()==='system'){
            param = 'LINK_TOTAL_SYSTEM_all'
            target = 'totalSystem'
            title = 'SYSTEM'
        }
        else if(flag.toLowerCase()==='mall'){
            param = 'MALL_EMP_LINK'
            target = 'empMall'
            title = '임직원 복지몰'
        }
        host += '/home/totalsystem'
        if (this.isTeams) {
            const modal: appbase.IModalOpenable = this.$refs['modal'] as any
            const options: appbase.TModalInfo<any> = {
                component: TotalSystemModal,
                props: {menuName:param, title:title},
                events: {
                    cancel: () => {
                        modal.closeModal()
                    },
                },
            }
            modal.openModal(options)
        }
        else
            window.open(`${host}?MENUNAME=${param}`, target, 'width=1100,height=800')
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    mounted() {
        //팝업 알림 대상 
        //App 설정으로 팝업 사용유무 확인 후 component init
        const popupConfig = this.current.appConfig.filter(config => {
            //      key:"UsePopupNotice"
            return config.key.toLowerCase() == "usepopupnotice"
        })

        if (popupConfig.length > 0) {
            if (popupConfig[0].value.toLowerCase() == "true") {
                this.isEnablePopupNotice = true
            }
        }
        //this.load()
    }

    async getPageList() {
        await webpartApi.page.get(this.current.user.comCode).then(r => {            
            this.pageId = r[0].pageId
            this.loadCommonInfo(this.user.isMailUser ? [
                WebpartDataType.UnreadMail,
                WebpartDataType.MonthlyEvent,
                WebpartDataType.DailyEvent
            ] : []);
        })
    }

    created() {
        // this.setTeams(true)
        // const body = document.querySelector('body')
        // if (body) {
        //   body.className = 'bg-body-basic'
        // }
        this.getPageList();
        //근퇴 관리 
        //C021 (한국법인만 사용)
        let coperationCode = this.current.user.personCode.split("_")[0]
        if (coperationCode === 'C021') this.useAttendance = true
    }

    beforeDestroy() {
        const body = document.querySelector('body')
        if (body) {
            body.className = ''
        }
    }
}
